import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=9a80aaea&"
import script from "./SearchList.vue?vue&type=script&lang=ts&"
export * from "./SearchList.vue?vue&type=script&lang=ts&"
import style0 from "./SearchList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports